module.exports = __webpack_public_path__ + "img/dataforce-block-bg-right-mobile.206ef426.svg";